import { styled } from '@goodfynd/react-web.theme';

export const StyledBody = styled('div', {
  flex: 1,
  fontSize: 16,
  maxWidth: 1440,
  padding: '24px 16px',
  paddingTop: 64,
  '@smMax': {
    minWidth: '100%',
  },
  '@lgMin': {
    margin: '0 auto',
    minWidth: 1440,
    padding: '48px 118px',
  },
  variants: {
    fullScreen: {
      false: {
        paddingTop: 24,
      },
      true: {
        padding: 0,
        paddingTop: 64,
        '@mdMax': {
          paddingTop: 32,
        },
      },
    },
  },
});

export const StyledPageContainer = styled('div', {
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
});
